import React, {useContext} from "react";
import IsMobileContext from "context/isMobile/isMobileContext";
import NuevaAlertaMovil from "./NuevaAlertaMovil"
import NuevaAlertaWeb from "./NuevaAlertaWeb"


export default function EditarDispositivo({ setOpen, init, update }) {

    const isMobile = useContext(IsMobileContext);
    const { isMobileUse } = isMobile;

    return (
        <>
        {isMobileUse() ? 
            <NuevaAlertaMovil init={init} setOpen={setOpen}  update={update}/>
        :
            <NuevaAlertaWeb init={init} setOpen={setOpen}  update={update}/>
        }
        </>
    );
};


